export class MyDocsModel {
    public id: any;
    public doc_name: string;
    public doc_desc: string;
    public comm_doc_str: string;
    public status: string;
    public editMode: boolean;
    public created_dt: Date;
    public comm_doc: File;
    public comm_plan_id: any;
    public comm_plan_desc: string;
    public user_type: string;
    public effective_dt: Date;
    public employeeId: any;
    public employeeName: string;
    public employeesList: string[];
    public created_by: string;
    public selected: boolean;
    public updated_by: string;
    public comment: string;
    public updated_dt: Date;
    public sc_emp_id: any;
    public tracking_id: string;
    public approved_dt: any;

    public approved_by: any;
    public approved_on: any;
    public approved_status: any;
    public comm_doc_id: any;

    public pending_from_dt: any;
    public scempId: any;
    public comm_plan: any;

    public salesChannel: any;
    public salesChannelDesc: any;
    public signoffdate: string;
    public uploadedDt: string;
    public eDate: string;

    constructor() {
        this.eDate = null;
        this.id = null;
        this.doc_name = '';
        this.doc_desc = '';
        this.comm_doc_str = '';
        this.status = '';
        this.editMode = false;
        this.created_dt = null;
        this.comm_doc = null;
        this.comm_plan_id = '';
        this.comm_plan_desc = '';
        this.user_type = '';
        this.effective_dt = null;
        this.employeeId = '';
        this.employeeName = '';
        this.employeesList = [];
        this.created_by = '';
        this.selected = false;
        this.updated_by = '';
        this.comment = '';
        this.updated_dt = null;
        this.sc_emp_id = 0;
        this.tracking_id = '';
        this.approved_dt = null;

        this.approved_by = null;
        this.approved_on = null;
        this.approved_status = null;
        this.comm_doc_id = null;

        this.pending_from_dt = null;
        this.scempId = null;
        this.comm_plan = null;

        this.salesChannel = null;
        this.salesChannelDesc = null;
        this.signoffdate = "";
        this.uploadedDt = "";
    }
}
